import React, { useEffect, useRef } from 'react';

const FlowingMeshCanvas = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let animationFrameId;
        let time = 0;

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        window.addEventListener("resize", resizeCanvas);
        resizeCanvas();

        const draw = () => {
            const { width, height } = canvas;
            ctx.clearRect(0, 0, width, height);

            const lines = 50;
            const amplitude = 80;
            const frequency = 0.002;
            const speed = 0.003;
            ctx.lineWidth = 0.8;

            for (let i = 0; i < lines; i++) {
                ctx.beginPath();
                const alpha = 0.1 + (i / lines) * 0.4;
                ctx.strokeStyle = `hsla(217, 54%, 24%, ${alpha})`;

                for (let x = 0; x <= width; x += 5) {
                    const yOffset = height / 2;
                    const y1 = Math.sin(x * frequency + time + i * 0.05) * amplitude;
                    const y2 = Math.sin(x * frequency * 0.5 + time * 0.5) * (amplitude * 0.5);
                    const tilt = (x / width) * 50;
                    ctx.lineTo(x, yOffset + y1 + y2 + tilt + (i * 3));
                }
                ctx.stroke();
            }

            time += speed;
            animationFrameId = requestAnimationFrame(draw);
        };

        draw();

        return () => {
            window.removeEventListener("resize", resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return <canvas ref={canvasRef} className="w-full h-full" />;
};

export default FlowingMeshCanvas;